import {  EDIT_SENSITIVITY_REQUEST } from '../constants/constants';

export const saveEditSensitivity = (payload) => {
    return {
      type: EDIT_SENSITIVITY_REQUEST,
      payload: payload,
    };
  };
